import { TFunction } from 'i18next';
import { CSSProperties } from 'react';
import { Languages } from '../../../../constants';
import { ValidationResponse } from '../../../types';
import { DashboardPageOptions } from '../../dashboards/types';
import { ExternalChartComponentProps } from '../../data-viz-containers/common/types';
import { Filter, Segment } from '../../filter/filterbar/types';
import { ItemsStateWithHistory } from '../../filter/types';
import { TimeSliderState } from '../../timeslider/types';
import { FactboxSingleMetricStoryboardComponentConfig } from '../factbox-single-metric/types';
import { FactboxTwoMetricStoryboardComponentConfig } from '../factbox-two-metric/types';
import { OverTimeSegmentedStoryboardComponentConfig } from '../over-time-segmented/types';
import { OverTimeUnsegmentedStoryboardComponentConfig } from '../over-time-unsegmented/types';
import { TimePeriodSegmentedStoryboardComponentConfig } from '../time-period-segmented/types';
import { TimePeriodUnsegmentedStoryboardComponentConfig } from '../time-period-unsegmented/types';

type GridColSpan = number;

type GridRowSpan = number;

type GridCols = number;

type GridRows = number;

type GridColStart = number;

type GridColEnd = number;

type GridRowStart = number;

type GridRowEnd = number;

export type LanguageString = Record<Languages, string>;

export type StoryboardItemLayoutConfig = {
  gridColSpan?: GridColSpan;
  gridRowSpan?: GridRowSpan;
  gridColStart?: GridColStart;
  gridColEnd?: GridColEnd;
  gridRowStart?: GridRowStart;
  gridRowEnd?: GridRowEnd;
};

export enum StoryboardComponentIds {
  TIME_PERIOD_SEGMENTED = 'timePeriodSegmented',
  TIME_PERIOD_UNSEGMENTED = 'timePeriodUnsegmented',
  OVERTIME_SEGMENTED = 'overtimeSegmented',
  OVERTIME_UNSEGMENTED = 'overtimeUnsegmented',
  FACTBOX_SINGLE_METRIC = 'factboxSingleMetric',
  FACTBOX_TWO_METRIC = 'factboxTwoMetric',
}

export type StoryboardItemConfig = {
  chartId: string;
  classNames?: string;
  layoutConfig: StoryboardItemLayoutConfig;
  // These two should be one, so it can potentially be pattern matched on
  componentConfig: StoryboardComponentConfig;
};

export type CommonStoryboardItemVizContainerProps = {
  externalProps: ExternalChartComponentProps;
};

export interface GlobalStateManager {
  state: {
    timeSliderState: TimeSliderState;
    filtersState: ItemsStateWithHistory<Filter>;
    segmentationState: ItemsStateWithHistory<Segment>;
  };
  actions: {};
}

export type StoryboardItemProps = {
  config: StoryboardItemConfig;
  pageOptions: DashboardPageOptions;
  layoutProps?: {
    padding?: CSSProperties['padding'];
  };
};

export interface StoryboardComponentSettings<
  StoryboardComponentConfig,
  VizContainerProps extends CommonStoryboardItemVizContainerProps,
> {
  componentId: StoryboardComponentIds;
  componentConfigToVizContainerProps: (
    componentConfig: StoryboardComponentConfig,
    externalProps: ExternalChartComponentProps,
    persistenceKey: string
  ) => VizContainerProps;
  VizContainerComponent: React.ComponentType<VizContainerProps>;
  validateConfig: (
    componentConfig: StoryboardComponentConfig,
    t: TFunction
  ) => ValidationResponse;
}

export type StoryboardComponentConfig =
  | OverTimeSegmentedStoryboardComponentConfig
  | OverTimeUnsegmentedStoryboardComponentConfig
  | FactboxSingleMetricStoryboardComponentConfig
  | FactboxTwoMetricStoryboardComponentConfig
  | TimePeriodSegmentedStoryboardComponentConfig
  | TimePeriodUnsegmentedStoryboardComponentConfig;
